<template>
    <div class="designerpage">

<!--        <div class="designeroption" v-if="!mdd">-->
<!--            <h3>-->
<!--                Customer Notice-->
<!--            </h3>-->
<!--            <div class="stylesoption">-->
<!--                Please note: due to constant out of stock issues from our suppliers we are temporarily removing the GRP door option.-->
<!--                <br/><br/>-->
<!--                The Solid Core door and Fire Door are still available. We apologise for any inconvenience this may cause.-->
<!--            </div>-->
<!--        </div>-->

        <futureproducts-designer-question-door-range v-if="range_panel_required"
                                                     :fabricator="fabricator"
                                                     v-model:target="door.attr.door_range"
                                                     :ranges="ranges"
                                                     :defaults="defaults()"
                                                     title="Choose a Door Range"
                                                     :reference_on="reference_on"></futureproducts-designer-question-door-range>

        <div>
            <wb-designer-question-select-door :fabricator="fabricator"
                                              :secured-by-design="door.attr.secured_by_design"
                                              :door-range="door.attr.door_range"
                                              v-model:target="door.attr.slab"></wb-designer-question-select-door>

            <designer-question-steel-inserts :fabricator="fabricator"
                                             :slab="door.attr.slab"
                                             v-model:target="door.attr.steel_inserts"
                                                ></designer-question-steel-inserts>

            <designer-question-frame-material :slab="door.attr.slab"
                                                 :fabricator="fabricator"
                                                 v-model:target="door.attr.frame_material"></designer-question-frame-material>
        </div>

        <div class="designeroption">
            <designer-question-hinge-side v-if="!is_french" :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>

            <designer-question-opening-direction v-show="technical_should_show" :fabricator="fabricator"
                                                 :type-range="door.attr.door_range"
                                                 v-model:target="door.attr.opening_direction"></designer-question-opening-direction>
        </div>

        <div v-if="is_french">
            <wb-designer-question-french-master :fabricator="fabricator" v-model:target="door.attr.french_master"
                                                title="Select Your Master Door"
            ></wb-designer-question-french-master>
        </div>

        <futureproducts-designer-question-select-frame-style v-show="!is_french && !slab_only && door.attr.door_range != 39"
                                                             :fabricator="fabricator"
                                                             :frame-material="door.attr.frame_material"
                                                             :is-firedoor="is_firedoorrange"
                                                             v-model:target="door.attr.frame_style"
        ></futureproducts-designer-question-select-frame-style>

        <wb-french-designer-question-select-frame-style :fabricator="fabricator"
                                                        :frame-material="door.attr.frame_material"
                                                        :is-firedoor="is_firedoorrange"
                                                        v-model:target="door.attr.frame_style"
                                                        v-if="is_french && !slab_only"></wb-french-designer-question-select-frame-style>

        <hallmark-designer-question-colour-range
            title="Colour Ranges"
            :fabricator="fabricator"
            :type-range="door.attr.door_range"
            v-model:target="door.attr.colour_range"
        ></hallmark-designer-question-colour-range>

        <div class="row">
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="external_colour">

                    <h3>Choose Your External Door Colour</h3>

                    <wb-designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                               :door-range="door.attr.door_range"
                                                               :colour-range="door.attr.colour_range"
                                                               v-model:target="door.attr.external_colour"></wb-designer-question-door-colour-external>

                    <div class="stylesoption">
                        <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.external_colour"
                                                      title="External Door Colour"
                                                      :numbers_only="true"
                                                      v-model:target="door.attr.external_colour_ral"></designer-question-ral-colour>
                    </div>

                </div>
            </div>
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="door_colour_internal">

                    <h3>Choose Your Internal Door Colour</h3>


                    <futureproducts-designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                                           :external-colour="door.attr.external_colour"
                                                                           :door-range="door.attr.door_range"
                                                                           :colour-range="door.attr.colour_range"
                                                                           v-model:target="door.attr.door_colour_internal"></futureproducts-designer-question-door-colour-internal>

                    <div class="stylesoption">
                        <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.door_colour_internal"
                                                      title="Internal Door Colour"
                                                      :numbers_only="true"
                                                      v-model:target="door.attr.door_colour_internal_ral"></designer-question-ral-colour>
                    </div>

                  <div class="stylesoption" v-show="!mdd">
                    <template v-if="[160,161].includes(door.attr.door_range)">
                      Edgeband colour will be black
                    </template>
                    <template v-else>
                      Edgeband colour will match internal skin
                    </template>
                  </div>

                </div>
            </div>
        </div>

        <div class="row" v-show="!slab_only">
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="frame_colour_external">

                    <h3>Choose Your External Frame Colour</h3>

                    <wb-designer-question-frame-colour-external :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                :door-range="door.attr.door_range"
                                                                :colour-range="door.attr.colour_range"
                                                                v-model:target="door.attr.frame_colour_external"></wb-designer-question-frame-colour-external>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_external"
                                                  title="External Frame Colour"
                                                  :numbers_only="true"
                                                  v-model:target="door.attr.frame_colour_external_ral"></designer-question-ral-colour>
                </div>
            </div>
            <div class="col-sm">
                <div class="designeroption" data-designer-component-id="frame_colour_internal">

                    <h3>Choose Your Internal Frame Colour</h3>

                    <wb-designer-question-frame-colour-internal :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :frame-colour-external="door.attr.frame_colour_external"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                :door-range="door.attr.door_range"
                                                                :colour-range="door.attr.colour_range"
                                                                v-model:target="door.attr.frame_colour_internal"></wb-designer-question-frame-colour-internal>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_internal"
                                                  title="Internal Frame Colour"
                                                  :numbers_only="true"
                                                  v-model:target="door.attr.frame_colour_internal_ral"></designer-question-ral-colour>
                </div>
            </div>
        </div>

        <div>

          <futureproducts-designer-question-secured-by-design v-show="!no_sbd" :fabricator="fabricator"
                                                    v-model:target="door.attr.secured_by_design"></futureproducts-designer-question-secured-by-design>

          <designer-question-door-glass-laminated v-show="door.attr.door_range !== 164"
                                                  :fabricator="fabricator"
                                                  title="Laminated Glass:"
                                                  :slab="door.attr.slab"
                                                  :frame-style="door.attr.frame_style"
                                                  :side-panels="door.attr.side_panels"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :is-firedoor="is_firedoorrange"
                                                  :door_range="door.attr.door_range"
                                                  v-model:target="door.attr.laminated_glass"
          ></designer-question-door-glass-laminated>

        </div>

        <div>
            <wb-designer-question-glass-design :fabricator="fabricator"
                                               v-model:target="door.attr.glass_design"
                                               :laminated-glass="door.attr.laminated_glass"
                                               :door-range="door.attr.door_range"
                                               :slab="door.attr.slab"></wb-designer-question-glass-design>

            <designer-question-glass-text v-model:target="door.attr.glass_text"
                                          :glass-design="door.attr.glass_design"></designer-question-glass-text>
        </div>

        <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                   v-model:target="door.attr.glass_backing_design"
                                                   :slab="door.attr.slab"
                                                   :glass-design="door.attr.glass_design"></wb-designer-question-glass-backing-design>

        <futureproducts-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                                  v-model:target="door.attr.side_panels"
                                                                  :door-range="door.attr.door_range"
                                                                  :frame-style="door.attr.frame_style"
                                                                  :frame-profile="door.attr.profile"
                                                                  :frame-material="door.attr.frame_material"
                                                                  :laminated-glass="door.attr.laminated_glass"
                                                                  :frame-colour-internal="door.attr.frame_colour_internal"
                                                                  :frame-colour-external="door.attr.frame_colour_external"
                                                                  :secured-by-design="door.attr.secured_by_design"
                                                                  :slab="door.attr.slab"
                                                                  :measurements.sync="door.attr.measurements"
                                                                  :cill="door.attr.cill"
                                                                  :threshold="door.attr.threshold"></futureproducts-designer-question-select-frame-sidepanels>


        <div>
            <futureproducts-designer-question-hardware-colour :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_colour"
                                                  :sbd="door.attr.secured_by_design"
                                                  :slab="door.attr.slab"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"
                                                  :opening-direction="door.attr.opening_direction"></futureproducts-designer-question-hardware-colour>
        </div>
        <div>
            <wb-designer-question-hardware-handle :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_handle"
                                                  :slab="door.attr.slab"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :hardware-colour="door.attr.hardware_colour"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"
                                                  :helper_text="handle_helper_text"
                                                  :extra_text="supplied_loose_extra_text(door.attr.hardware_handle)"
            ></wb-designer-question-hardware-handle>

            <futureproducts-designer-question-hardware-handle-internal :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_handle_internal"
                                                           :slab="door.attr.slab"
                                                           :secured-by-design="door.attr.secured_by_design"
                                                           :opening-direction="door.attr.opening_direction"
                                                           :hardware-colour="door.attr.hardware_colour"
                                                           :door-range="door.attr.door_range"
                                                           :profile="door.attr.profile"
                                                           :handle-external="door.attr.hardware_handle"
                                                           :extra_text="supplied_loose_extra_text(door.attr.hardware_handle_internal)"
                                                           :select_first_after_update_prop="true"
            ></futureproducts-designer-question-hardware-handle-internal>

            <designer-question-nuki-accessories
              v-if="door.attr.hardware_handle_internal"
              :fabricator="fabricator"
              :hardware-handle-internal="door.attr.hardware_handle_internal"
              v-model:nuki-key-pad="door.attr.nuki_keypad"
              v-model:nuki-key-fob="door.attr.nuki_keyfob"
              :fabricator_name="'futureproducts'"
            ></designer-question-nuki-accessories>

            <futureproducts-designer-question-hardware-handle-slave :door-range="door.attr.door_range" :fabricator="fabricator"
                                                        :hardware-colour="door.attr.hardware_colour"
                                                        :hardware-handle="door.attr.hardware_handle"
                                                        :hardware-suite="door.attr.suite"
                                                        :opening-direction="door.attr.opening_direction"
                                                        :profile="door.attr.profile"
                                                        :secured-by-design="door.attr.secured_by_design"
                                                        :slab="door.attr.slab"
                                                        v-model:target="door.attr.hardware_handle_slave"
                                                        title="Select Your Slave Handle"
                                                        v-if="is_french"
                                                        :extra_text="supplied_loose_extra_text(door.attr.hardware_handle_slave)"
            ></futureproducts-designer-question-hardware-handle-slave>

            <designer-question-hardware-handle-split-spindle v-show="technical_should_show" :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_handle_split_spindle"
                                                             :hardware-handle="door.attr.hardware_handle"
                                                             :slab="door.attr.slab"></designer-question-hardware-handle-split-spindle>

            <div v-show="!is_firedoorrange">
                <designer-question-hardware-decorative-handle :fabricator="fabricator"
                                                              v-model:target="door.attr.hardware_decorative_handle"
                                                              :slab="door.attr.slab"
                                                              :hardware-colour="door.attr.hardware_colour"
                                                              :door-range="door.attr.door_range"
                                                              :extra_text="supplied_loose_extra_text(door.attr.hardware_decorative_handle)"
                ></designer-question-hardware-decorative-handle>

                <designer-question-hardware-decorative-handle-position :fabricator="fabricator"
                                                                       v-model:target="door.attr.hardware_decorative_handle_pos"
                                                                       :slab="door.attr.slab"
                                                                       :frame-material="door.attr.frame_material"
                                                                       :hardware-decorative-handle="door.attr.hardware_decorative_handle"></designer-question-hardware-decorative-handle-position>
            </div>
        </div>
        <div>
            <wb-designer-question-hardware-escutcheon :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_escutcheon"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :hardware-handle-internal="door.attr.hardware_handle_internal"
                                                      :door-range="door.attr.door_range"
                                                      :profile="door.attr.profile"
            ></wb-designer-question-hardware-escutcheon>

            <designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon"></designer-question-hardware-escutcheon-position>
        </div>

        <div v-if="is_stable">
            <wb-designer-question-hardware-escutcheon-stable :door-range="door.attr.door_range"
                                                             :fabricator="fabricator"
                                                             :hardware-colour="door.attr.hardware_colour"
                                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                             :hardware-handle="door.attr.hardware_handle"
                                                             :secured-by-design="door.attr.secured_by_design"
                                                             :slab="door.attr.slab"
                                                             v-model:target="door.attr.hardware_escutcheon_stable"
                                                             title="Stable Bottom Leaf Escutcheon"></wb-designer-question-hardware-escutcheon-stable>

            <wb-designer-question-hardware-escutcheon-stable-position :door-range="door.attr.door_range"
                                                                      :fabricator="fabricator"
                                                                      :frame-material="door.attr.frame_material"
                                                                      :hardware-escutcheon="door.attr.hardware_escutcheon_stable"
                                                                      :slab="door.attr.slab"
                                                                      v-model:target="door.attr.hardware_escutcheon_stable_pos"></wb-designer-question-hardware-escutcheon-stable-position>
        </div>

        <div v-show="technical_should_show">
            <designer-question-hardware-lock :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_lock"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :hinge-side="door.attr.hinge_side"
                                             :slab="door.attr.slab"
                                             :frame-material="door.attr.frame_material"
                                             :hardware-handle="door.attr.hardware_handle"
                                             :opening_direction="door.attr.opening_direction"
                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                             :door-range="door.attr.door_range"
                                             :maintitle="'Choose Your Lock'"
            ></designer-question-hardware-lock>

            <designer-question-hardware-cylinder-tiled
              v-show="technical_should_show"
              :fabricator="fabricator"
              title="Choose Your Cylinder"
              :slab="door.attr.slab"
              v-model:target="door.attr.hardware_cylinder"
              :secured-by-design="door.attr.secured_by_design"
              :hardware-lock="door.attr.hardware_lock"
              :hardware-colour="door.attr.hardware_colour"
              :opening_direction="door.attr.opening_direction"
              :hardware-handle="door.attr.hardware_handle"
              :door-range="door.attr.door_range"
              :hardware-handle-internal="door.attr.hardware_handle_internal"
            ></designer-question-hardware-cylinder-tiled>
        </div>

        <designer-question-tedee-accessories
          v-if="door.attr.hardware_cylinder"
          :fabricator="fabricator"
          :hardware-cylinder="door.attr.hardware_cylinder"
          v-model:tedee-key-pad="door.attr.tedee_keypad"
          v-model:tedee-bridge="door.attr.tedee_bridge"
          :fabricator_name="'futureproducts'"
        ></designer-question-tedee-accessories>

        <!--<div v-if="is_stable">-->
            <!--<wb-designer-question-hardware-joining-bolt :door-range="door.attr.door_range"-->
                                                        <!--:fabricator="fabricator"-->
                                                        <!--:slab="door.attr.slab"-->
                                                        <!--v-model:target="door.attr.hardware_joining_bolt"-->
                                                        <!--title="Choose your Rack Bolt"></wb-designer-question-hardware-joining-bolt>-->

            <!--<wb-designer-question-hardware-joining-bolt-position :door-range="door.attr.door_range"-->
                                                                 <!--:fabricator="fabricator"-->
                                                                 <!--:frame-material="door.attr.frame_material"-->
                                                                 <!--:hardware-joining-bolt="door.attr.hardware_joining_bolt"-->
                                                                 <!--:slab="door.attr.slab"-->
                                                                 <!--v-model:target="door.attr.hardware_joining_bolt_pos"></wb-designer-question-hardware-joining-bolt-position>-->
        <!--</div>-->

        <div>
            <wb-designer-question-hardware-letterbox :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox"
                                                     :secured-by-design="door.attr.secured_by_design"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :door-range="door.attr.door_range"></wb-designer-question-hardware-letterbox>

            <designer-question-hardware-letterbox-cowl :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_letterbox_cowl"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-letterplate="door.attr.hardware_letterbox"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-letterbox-cowl>

            <designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_letterbox_pos"
                                                           :slab="door.attr.slab"
                                                           :side-panels="door.attr.side_panels"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"
                                                           :door-range="door.attr.door_range"></designer-question-hardware-letterbox-position>
        </div>
        <div v-if="!slab_only">
            <wb-designer-question-hardware-knocker :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_knocker"
                                                   :slab="door.attr.slab"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-spyhole="door.attr.hardware_spy_hole"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :door-range="door.attr.door_range"
                                                   :extra_text="supplied_loose_extra_text(door.attr.hardware_knocker)"
            ></wb-designer-question-hardware-knocker>

            <designer-question-hardware-knocker-position :fabricator="fabricator"
                                                         v-model:target="door.attr.hardware_knocker_pos"
                                                         :slab="door.attr.slab"
                                                         :frame-material="door.attr.frame_material"
                                                         :hardware-knocker="door.attr.hardware_knocker"
                                                         :door-range="door.attr.door_range"></designer-question-hardware-knocker-position>
        </div>
        <div>
            <wb-designer-question-hardware-spy-hole :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_spy_hole"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :glass-design="door.attr.glass_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :door-range="door.attr.door_range"
                                                    :extra_text="supplied_loose_extra_text(door.attr.hardware_spy_hole)"
            ></wb-designer-question-hardware-spy-hole>

            <designer-question-hardware-spy-hole-position :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_spy_hole_pos"
                                                          :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                          :door-range="door.attr.door_range"></designer-question-hardware-spy-hole-position>
        </div>
        <div class="designeroption" v-show="technical_should_show && !slab_only">
            <designer-question-hardware-numerals :fabricator="fabricator"
                                                 v-model:target="door.attr.numerals"
                                                 :slab="door.attr.slab"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :type-range="door.attr.door_range"
                                                 title="Numerals"
                                                 extra_text="These items are supplied loose"
            ></designer-question-hardware-numerals>
        </div>

        <designer-question-hinge-qty
            :fabricator="fabricator"
            :type-range="door.attr.door_range"
            :hardware-handle="door.attr.hardware_handle"
            v-model:target="door.attr.hinge_qty"
        ></designer-question-hinge-qty>

        <futureproducts-designer-question-hardware-hinge v-if="slab_only" :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_hinge"
                                             :slab="door.attr.slab"
                                             :opening_direction="door.attr.opening_direction"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :hardware-colour="door.attr.hardware_colour"
                                             :hinge-side="door.attr.hinge_side"
                                             :frame-material="door.attr.frame_material"
                                             :door-range="door.attr.door_range"
                                             :hinge-qty="door.attr.hinge_qty"
                                             :hardware-handle="door.attr.hardware_handle"
        ></futureproducts-designer-question-hardware-hinge>

        <futureproducts-designer-question-hardware-hinge-tiled v-if="!slab_only" :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_hinge"
                                             :slab="door.attr.slab"
                                             :opening_direction="door.attr.opening_direction"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :hardware-colour="door.attr.hardware_colour"
                                             :hinge-side="door.attr.hinge_side"
                                             :frame-material="door.attr.frame_material"
                                             :door-range="door.attr.door_range"
                                             :hinge-qty="door.attr.hinge_qty"
                                             :hardware-handle="door.attr.hardware_handle"
        ></futureproducts-designer-question-hardware-hinge-tiled>

        <div>
            <designer-question-hardware-security-chain v-if="!slab_only" :fabricator="fabricator"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       v-model:target="door.attr.hardware_security_chain"
                                                       :hardware-colour="door.attr.hardware_colour"
                                                       :door-range="door.attr.door_range"
                                                       extra_text="These items are supplied loose"
            ></designer-question-hardware-security-chain>
        </div>

        <div v-if="is_firedoorrange || door.attr.door_range == 38">
            <futureproducts-designer-question-closer
              :fabricator="fabricator"
              v-model:target="door.attr.closer"
              :slab="door.attr.slab"
              :slab-width="door.attr.measurements.slab_width"
              :door-range="door.attr.door_range"
              :title="'Choose Closer'"
            ></futureproducts-designer-question-closer>
        </div>

        <div class="designeroption">
          <h3>Door Extras</h3>
          <designer-question-collection-option :fabricator="fabricator"
                                               v-model:target="door.attr.touch_up_kit"
                                               :question="'touch_up_kit'"
                                               :title="'Touch Up Kit'"
                                               :fabricator_name="'futureproducts'"
          ></designer-question-collection-option>
        </div>

        <div v-show="technical_should_show">
            <wb-designer-question-technical-profile :fabricator="fabricator"
                                                    :frame-colour-internal="door.attr.frame_colour_internal"
                                                    :frame-colour-external="door.attr.frame_colour_external"
                                                    :frame-material="door.attr.frame_material"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                    :door-range="door.attr.door_range"
                                                    :opening-direction="door.attr.opening_direction"
                                                    :frame-combination="door.attr.frame_style.frame_id"
                                                    v-model:target="door.attr.profile"></wb-designer-question-technical-profile>
        </div>

        <div v-show="technical_should_show && !slab_only && door.attr.door_range != 39">
            <futureproducts-designer-question-addons :fabricator="fabricator"
                                         v-model:target="door.attr.addons"
                                         :frame-profile="door.attr.profile"
                                         :frame-colour-internal="door.attr.frame_colour_internal"
                                         :frame-colour-external="door.attr.frame_colour_external"
                                         :frame-style="door.attr.frame_style"
            ></futureproducts-designer-question-addons>
        </div>

        <div v-show="technical_should_show && !slab_only">
          <designer-question-technical-coupler :fabricator="fabricator"
                                               v-model:target="door.attr.couplers"
                                               :frame-profile="door.attr.profile"
                                               :frame-combination="door.attr.frame_style.frame_id"
                                               :title="'Select Coupler size'">
          </designer-question-technical-coupler>
        </div>

        <div v-show="technical_should_show && !slab_only">
            <futureproducts-designer-question-technical-threshold :fabricator="fabricator"
                                                                  title="Choose Your Threshold"
                                                                  v-model:target="door.attr.threshold"
                                                                  :opening-direction="door.attr.opening_direction"
                                                                  :frame-profile="door.attr.profile"
                                                                  :cill="door.attr.cill"
                                                                  :door-range="door.attr.door_range"></futureproducts-designer-question-technical-threshold>




            <designer-question-sidepanel-threshold v-if="passed_filter_left && !is_firedoorrange" :fabricator="fabricator"
                                                   title="Choose Your Left Side Threshold"
                                                   v-model:target="door.attr.side_panels.left_threshold_id"
                                                   :frame-profile="door.attr.profile"
                                                   :threshold="door.attr.threshold"
                                                   :door-range="door.attr.door_range"></designer-question-sidepanel-threshold>




            <designer-question-sidepanel-threshold v-if="passed_filter_right && !is_firedoorrange" :fabricator="fabricator"
                                                   title="Choose Your Right Side Threshold"
                                                   v-model:target="door.attr.side_panels.right_threshold_id"
                                                   :frame-profile="door.attr.profile"
                                                   :threshold="door.attr.threshold"
                                                   :door-range="door.attr.door_range"></designer-question-sidepanel-threshold>

        </div>

        <div class="designeroption" v-show="technical_should_show && !slab_only">
            <h3>Select Any Required Sills</h3>
            <designer-question-technical-cill :fabricator="fabricator"
                                              v-model:target="door.attr.cill"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :opening-direction="door.attr.opening_direction"
                                              :frame-profile="door.attr.profile"
                                              :threshold="door.attr.threshold"
                                              :door-range="door.attr.door_range"
                                              :component_id="'cill'"
                                              :show_cill_horn_text="door.attr.door_range !== 164"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="left_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.left_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :door-range="door.attr.door_range"
                                              :title="'Left Sidepanel Flag'"
                                              :component_id="'left_flag_cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="right_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.right_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :door-range="door.attr.door_range"
                                              :title="'Right Sidepanel Flag'"
                                              :component_id="'right_flag_cill'"
            ></designer-question-technical-cill>

        </div>

        <div>
            <div v-show="technical_should_show">

                <wb-designer-question-door-drip-colour :fabricator="fabricator"
                                                       title="Choose A Door Drip colour"
                                                       :external-colour="door.attr.external_colour"
                                                       :door-range="door.attr.door_range"
                                                       v-model:target="door.attr.door_drip_colour"
                                                       :frame-profile="door.attr.profile"></wb-designer-question-door-drip-colour>

                <futureproducts-designer-question-head-drip-colour v-if="!is_firedoorrange" :fabricator="fabricator"
                                                                   title="Choose A Head Drip colour"
                                                                   :external-colour="door.attr.external_colour"
                                                                   v-model:target="door.attr.head_drip_colour"
                                                                   :frame-profile="door.attr.profile"
                                                                   :opening-direction="door.attr.opening_direction"></futureproducts-designer-question-head-drip-colour>

                <futureproducts-designer-question-technical-drainage v-if="!slab_only" :fabricator="fabricator"
                                                                     v-model:target="door.attr.drainage"
                                                                     :cill="door.attr.cill"
                                                                     :threshold="door.attr.threshold"></futureproducts-designer-question-technical-drainage>

                <div v-if="is_stable">
                    <div class="designeroption" data-designer-component-id="meeting_bar_style">
                        <h3>Select Your Stable Meeting Styles</h3>
                        <div class="stylesoption">
                            <div class="row">
                                <div class="col-md">
                                    <designer-question-meeting-rail-colour
                                        :fabricator="fabricator"
                                        title="Bottom Meeting Style (Outside)"
                                        :door-colour="door.attr.external_colour"
                                        v-model:target="door.attr.meeting_bar_outside"
                                        :frame-profile="door.attr.profile"
                                    ></designer-question-meeting-rail-colour>
                                </div>
                                <div class="col-md">
                                    <designer-question-meeting-rail-colour
                                        :fabricator="fabricator"
                                        title="Top Meeting Style (Inside)"
                                        :door-colour="door.attr.door_colour_internal"
                                        v-model:target="door.attr.meeting_bar_inside"
                                        :frame-profile="door.attr.profile"
                                        :meeting-rail-outside="door.attr.meeting_bar_outside"
                                    ></designer-question-meeting-rail-colour>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div v-show="technical_should_show">
            <futureproducts-designer-question-measurements title="Enter Your Required Measurements"
                                                           :fabricator="fabricator"
                                                           :slab="door.attr.slab"
                                                           :door-range="door.attr.door_range"
                                                           :external-colour="door.attr.external_colour"
                                                           :internal-colour="door.attr.door_colour_internal"
                                                           :frame-profile="door.attr.profile"
                                                           :threshold="door.attr.threshold"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :side-panels="door.attr.side_panels"
                                                           :addons="door.attr.addons"
                                                           :cill="door.attr.cill"
                                                           :hardware-lock="door.attr.hardware_lock"
                                                           :hardware-hinge="door.attr.hardware_hinge"
                                                           :hardware-handle="door.attr.hardware_handle"
                                                           :hardware-knocker="door.attr.hardware_knocker"
                                                           :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                           :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"
                                                           :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                                           :overall-width="door.attr.measurements.overall_width"
                                                           :mdd="mdd"
                                                           :technical_should_show="technical_should_show"
                                                           v-model:target="door.attr.measurements"></futureproducts-designer-question-measurements>

            <div class="designeroption" data-designer-component-id="cill_measurements" v-show="false">
                <h3>{{ cillLabel }} Measurements</h3>
                <designer-question-technical-cill-measure v-if="sill_measure" :fabricator="fabricator"
                                                          v-model:target="door.attr.cill_measure"
                                                          :title="cillLabel + ' Length (mm)'"
                                                          :cill="door.attr.cill"
                                                          :measurements="door.attr.measurements"
                                                          :cill_type="'door'"
                ></designer-question-technical-cill-measure>

                <designer-question-technical-cill-measure v-if="left_flag_sill && left_sill_measure"
                                                          :fabricator="fabricator"
                                                          v-model:target="door.attr.left_flag_cill_measure"
                                                          :title="'Left Sidepanel Flag '+cillLabel+' Length (mm)'"
                                                          :cill="door.attr.cill"
                                                          :measurements="door.attr.measurements"
                                                          :cill_type="'left'"
                ></designer-question-technical-cill-measure>

                <designer-question-technical-cill-measure v-if="right_flag_sill && right_sill_measure"
                                                          :fabricator="fabricator"
                                                          v-model:target="door.attr.right_flag_cill_measure"
                                                          :title="'Right Sidepanel Flag '+cillLabel+' Length (mm)'"
                                                          :cill="door.attr.cill"
                                                          :measurements="door.attr.measurements"
                                                          :cill_type="'right'"
                ></designer-question-technical-cill-measure>
            </div>

        </div>

        <div class="designeroption" v-if="door.attr.door_range == 39">
            <h3>FIRE DOOR NOTIFICATION - PLEASE BE AWARE:</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <p>
                        Due to recent changes (Nov 1 2019) in European Law relating to the supply of Fire Doors,
                        the SolidCore certified FD30s should only to be used as an internal door set with resistance to fire and smoke and should not be specified or installed as an external door set.
                    </p>
                    <p>
                        For reference, the definition of an external door set as defined in BS EN 14351-1:2006 is a ‘door set, which separates the internal climate from the external climate of a construction for which the main intended use is the passage of pedestrians’.
                    </p>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="firedoor_notice_checked">
                            <span class="checkbox-label">Check this box to confirm you have read and understood the above.</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
            <h3>Enter A Door Reference</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
                </div>
            </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control" value="Retail Door">

      <div class="designeroption" v-show="!mdd">
        <div class="stylesoption">
          <strong>If you cannot see what you are looking for on our portal then please email <a href="mailto:sales@futureproductsltd.com">sales@futureproductsltd.com</a> or call the Sales Office for advice prior to ordering. Thank you.</strong>
        </div>
      </div>

        <designer-navigation
                v-if="show_navigation"
                :visible_designer_configurator_components="visible_designer_configurator_components"
                transition="designer-navigation"
        ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
    import DoorConfigurator from "../DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator
        ],
        computed: {
            slab_only() {
              return this.door.attr.door_range === 120 || this.door.attr.door_range === 121 || this.door.attr.door_range === 122 || this.door.attr.door_range === 123 || this.door.attr.door_range === 161;
            },
            no_sbd() {
                return this.door.attr.door_range === 39 || this.door.attr.door_range === 116 || this.door.attr.door_range === 117 || this.slab_only || this.is_firedoorrange;
            },
            is_firedoorrange(){
                return this.door_type === 'fire';
            },
            is_french(){
                return this.door_type === 'french';
            },
            is_stable(){
                return this.door_type === 'stable';
            },
            passed_filter_left(){
                return this.door.attr.frame_material === 1 && this.door.attr.frame_style.checkedPanels.indexOf("left") !== -1;
            },
            passed_filter_right(){
                return this.door.attr.frame_material === 1 && this.door.attr.frame_style.checkedPanels.indexOf("right") !== -1;
            },
            handle_helper_text(){
                return this.slab_only ? "" : "<span style=\'font-weight:bold;text-decoration:underline;\'>Please Note: You can now mix and match our hardware suites. Please bear in mind that mixed selections will have a different finish and the colour will not match.</span>";
            },
            sill_measure() {
                return this.door.attr.cill !== 149;
            },
            left_sill_measure() {
                return this.door.attr.side_panels.left_flag_sill_id !== 149;
            },
            right_sill_measure() {
                return this.door.attr.side_panels.right_flag_sill_id !== 149;
            },
            left_sill() {
                if (this.left_flag_sill) {
                    return false;
                }
                return this.door.attr.side_panels !== undefined && this.door.attr.frame_style.checkedPanels.indexOf('left') !== -1
            },
            right_sill() {
                if (this.right_flag_sill) {
                    return false;
                }
                return this.door.attr.side_panels !== undefined && this.door.attr.frame_style.checkedPanels.indexOf('right') !== -1
            },
            cillLabel() {
                return window.trans('general.cill');
            },
        },
        data() {
            return {
                firedoor_notice_checked: false,
                supplied_loose_item_ids: [
                  1382, 1385, 1393, 1429, 1431, 1432, 2575, 2576, 498, 1221, 1222, 1224, 326,
                  692, 693, 694, 695, 696, 697, 698, 699, 700, 701, 702, 703, 704, 705, 706,
                  707, 708, 709, 710, 711, 722, 723, 724, 725, 726, 727, 728, 729, 730, 731,
                  732, 733, 734, 735, 736, 737, 738, 739, 740, 741, 1253, 1254, 1255, 1256,
                  1257, 1258, 1259, 1260, 1261, 1262, 1273, 1274, 1275, 1276, 1277, 1278, 1279,
                  1280, 1281, 1282, 1487, 1488, 1489, 1490, 1491, 1492, 1493, 1494, 1495, 1496,
                  1497, 1498, 1499, 1500, 1501, 1502, 1503, 1504, 1505, 1506, 1507, 1508, 1509,
                  1510, 1517, 1518, 1519, 1520, 1521, 1522, 1553, 1554, 1555, 1556, 1557, 1558,
                  1559, 1560, 1561, 1562, 1563, 1564, 1565, 1566, 1567, 1568, 1569, 1570, 1571,
                  1572, 1573, 1574, 1575, 1576, 1577, 1578, 1579, 1580, 1581, 1582, 1771, 1772,
                  1773, 1774, 1775, 1776, 1925, 1926, 1927, 1928, 1929, 1930, 1931, 1932, 1933,
                  1950, 1951, 1952, 1953, 1954, 1955, 1956, 1957, 1958, 1959, 1960, 1961, 1962,
                  2149, 2150, 2151, 2152, 2153, 2154, 2155, 2156, 2157, 2158, 2160, 2161, 2162,
                  553, 554
                ],
            }
        },
        methods: {
            handleAddToBasket() {
                if(this.mdd) {
                    this.add_door_to_basket(false);
                } else {
                    window.axios.post('/check-for-long-lead-time-on-profile', {
                        profile_id: this.door.attr.profile,
                    }).then((response) => {

                        if (response.data.status === true) {
                            return window.Swal.fire({
                                title: 'Long Lead Time',
                                text: `Please note the Frame and Colour combination you have selected will carry a ${response.data.lead_time} working day lead time`,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                showCancelButton: true,
                                confirmButtonText: 'Proceed Anyway',
                                cancelButtonText: 'Return to Designer'
                            }).then(result => {
                                if (result.dismiss === 'cancel') {
                                    return Promise.reject('stop');
                                }
                            });
                        }

                    }).then(() => {
                        if (this.door.attr.door_range == 39 && !this.firedoor_notice_checked) {
                            return window.Swal.fire({
                                title: 'Confirmation Required',
                                text: 'Please confirm you have read the Fire Door Notification',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                            });
                        }
                    }).then(() => {
                        this.add_door_to_basket(false);
                    });
                }
            },
            defaults() {
                return {
                    38: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 38,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_handle_internal": 2483,
                            "hardware_hinge": 1995,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 841,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1358,
                            "hardware_cylinder": 449,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 10785,
                            "threshold": 144190,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": null,
                                "right_threshold_id": null,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 13
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null,
                                "slab_width": "-124",
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    39: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 39,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 173,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_hinge": 1355,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 861,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 2,
                            "hardware_lock": 1720,
                            "hardware_cylinder": 449,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 10785,
                            "threshold": 10275,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": null,
                                "right_threshold_id": null,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 13
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null, "slab_width": "-124"},
                            "closer": 562,
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "hardware_handle_internal": 2474,
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    76: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 76,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 61,
                            "door_drip_colour": 1,
                            "external_colour": 61,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_hinge": 1995,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 1038,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1358,
                            "hardware_cylinder": 449,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 10785,
                            "threshold": 10005,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    77: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 77,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_hinge": 1995,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 874,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1358,
                            "hardware_cylinder": 449,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 10785,
                            "threshold": 10005,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    78: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 78,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_hinge": 1995,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 1112,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1358,
                            "hardware_cylinder": 449,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 10785,
                            "threshold": 10005,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    85: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 85,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_hinge": 2004,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 841,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1358,
                            "hardware_cylinder": 2523,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 10785,
                            "threshold": 144190,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 13
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null,
                                "slab_width": "-124"
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    116: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 116,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_hinge": 2004,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 867,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 2451,
                            "hardware_cylinder": 1921,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 10785,
                            "threshold": 144190,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": 180232,
                                "right_threshold_id": 180232,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 13
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null,
                                "slab_width": "-124"
                            },
                            "french_master": 1,
                            "hardware_handle_slave": 2408,
                            "hardware_escutcheon_pos": 27575,
                            "hinge_qty": 30,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "hardware_handle_internal": 2483
                        }
                    },
                    117: {
                        "attr": {
                            "fabricator":13,
                            "door_range":117,
                            "colour_range": 5,
                            "suite":10,
                            "frame_colour_external":1,
                            "door_colour_internal":1,
                            "door_drip_colour":1,
                            "external_colour":1,
                            "frame_colour_internal":1,
                            "frame_material":1,
                            "glass_design":1,
                            "glass_text":"",
                            "hardware_colour":22,
                            "hardware_handle":2431,
                            "hardware_hinge":2004,
                            "hinge_side":1,
                            "opening_direction":1,
                            "secured_by_design":1,
                            "slab":1843,
                            "frame_style":{
                                "frame_id":1,
                                "checkedPanels":[

                                ]
                            },
                            "laminated_glass":1,
                            "hardware_lock":2448,
                            "hardware_cylinder":449,
                            "hardware_security_chain":317,
                            "hardware_letterbox":318,
                            "hardware_knocker":315,
                            "hardware_spy_hole":316,
                            "profile":10785,
                            "threshold":144190,
                            "side_panels":{
                                "left_composite_id":882,
                                "right_composite_id":882,
                                "left":1,
                                "right":1,
                                "left_panel_glass_id":19,
                                "right_panel_glass_id":19,
                                "top_panel_glass_id":19,
                                "left_composite_glass_id":null,
                                "right_composite_glass_id":null,
                                "left_threshold_id":180232,
                                "right_threshold_id":180232,
                                "side_glass_text":{
                                    "text":"",
                                    "position":null
                                }
                            },
                            "numerals":[
                                326,
                                326,
                                326,
                                326
                            ],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill":149,
                            "drainage":1,
                            "measurements":{
                                "overall_width":null,
                                "overall_height":null,
                                "left_width":null,
                                "right_width":null,
                                "top_box_drop":null,
                                "slab_width":"-124"
                            },
                            "hinge_qty": 30,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    120: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 120,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 82,
                            "frame_colour_internal": 82,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_material": 99,
                            "glass_design": 149,
                            "glass_text": "",
                            "hardware_colour": 16986,
                            "hardware_handle": 1107,
                            "hardware_hinge": 2679,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 1932,
                            "frame_style": {
                                "frame_id": 65,
                                "checkedPanels": []
                            },
                            "laminated_glass": 1,
                            "hardware_lock": 2504,
                            "hardware_cylinder": 327,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 120911,
                            "threshold": 120912,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": null,
                                "right_threshold_id": null,
                                "side_glass_text": {
                                    "text": "",
                                    "position": null
                                }
                            },
                            "numerals": [
                                326,
                                326,
                                326,
                                326
                            ],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null,
                                "slab_width": "0"
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    121: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 121,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 82,
                            "frame_colour_internal": 82,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_material": 99,
                            "glass_design": 149,
                            "glass_text": "",
                            "hardware_colour": 16986,
                            "hardware_handle": 1107,
                            "hardware_hinge": 2679,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2005,
                            "frame_style": {"frame_id": 65, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 2504,
                            "hardware_cylinder": 327,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 120911,
                            "threshold": 120912,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": null,
                                "right_threshold_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null,
                                "slab_width": "0"
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    122: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 122,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 82,
                            "frame_colour_internal": 82,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_material": 99,
                            "glass_design": 149,
                            "glass_text": "",
                            "hardware_colour": 16986,
                            "hardware_handle": 1107,
                            "hardware_hinge": 2679,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 1983,
                            "frame_style": {"frame_id": 65, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 2504,
                            "hardware_cylinder": 327,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 120911,
                            "threshold": 120912,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": null,
                                "right_threshold_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null,
                                "slab_width": "0"
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    123: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 123,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 82,
                            "frame_colour_internal": 82,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_material": 99,
                            "glass_design": 149,
                            "glass_text": "",
                            "hardware_colour": 16986,
                            "hardware_handle": 1107,
                            "hardware_hinge": 2679,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2001,
                            "frame_style": {"frame_id": 65, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 2504,
                            "hardware_cylinder": 327,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 120911,
                            "threshold": 120912,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": null,
                                "right_threshold_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null,
                                "slab_width": "0"
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    126: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 126,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_hinge": 1995,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2069,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1358,
                            "hardware_cylinder": 449,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 144613840,
                            "threshold": 144613959,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 13
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null, "slab_width": "-104"},
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "hardware_handle_internal": 2474,
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        },
                    },
                    160: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 160,
                            "colour_range": 25,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 61,
                            "door_drip_colour": 61,
                            "external_colour": 61,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_hinge": 1995,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2737,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1358,
                            "hardware_cylinder": 449,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 10785,
                            "threshold": 144190,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 13
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null, "slab_width": "-124"},
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "hardware_handle_internal": 2483,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    161: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 161,
                            "colour_range": 25,
                            "suite": 10,
                            "frame_colour_external": 82,
                            "frame_colour_internal": 82,
                            "door_colour_internal": 61,
                            "door_drip_colour": 82,
                            "external_colour": 61,
                            "frame_material": 99,
                            "glass_design": 149,
                            "glass_text": "",
                            "hardware_colour": 16986,
                            "hardware_handle": 1107,
                            "hardware_hinge": 2679,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2738,
                            "frame_style": {"frame_id": 65, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 2504,
                            "hardware_cylinder": 327,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 120911,
                            "threshold": 120912,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": null,
                                "right_threshold_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null, "slab_width": "0"},
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    164: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 164,
                            "colour_range": 30,
                            "suite": 18,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 3,
                            "glass_design": 173,
                            "glass_text": "",
                            "hardware_colour": 67,
                            "hardware_handle": 412,
                            "hardware_hinge": 414,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2768,
                            "frame_style": {"frame_id": 31, "checkedPanels": []},
                            "laminated_glass": 2,
                            "hardware_lock": 396,
                            "hardware_cylinder": 2522,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 4221,
                            "threshold": 144629718,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 24,
                                "right_panel_glass_id": 24,
                                "top_panel_glass_id": 24,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": null,
                                "right_threshold_id": null,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 13
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 144629722,
                            "drainage": 1,
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null, "slab_width": "-124"},
                            "closer": 1125,
                            "hinge_qty": 30,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    171: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 171,
                            "colour_range": 31,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 61,
                            "door_drip_colour": 61,
                            "external_colour": 61,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_handle_internal": 2483,
                            "hardware_hinge": 1995,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2907,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1358,
                            "hardware_cylinder": 449,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 10785,
                            "threshold": 144190,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": null,
                                "right_threshold_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null,
                                "slab_width": "-124"
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "closer": 598,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    173: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 173,
                            "colour_range": 5,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_handle_internal": 2483,
                            "hardware_hinge": 1995,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2941,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 3650,
                            "hardware_cylinder": 449,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 10785,
                            "threshold": 144190,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": null,
                                "right_threshold_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null,
                                "slab_width": "-124"
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    },
                    174: {
                        "attr": {
                            "fabricator": 13,
                            "door_range": 174,
                            "colour_range": 31,
                            "suite": 10,
                            "frame_colour_external": 1,
                            "door_colour_internal": 61,
                            "door_drip_colour": 61,
                            "external_colour": 61,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 972,
                            "hardware_handle_internal": 2483,
                            "hardware_hinge": 1995,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2949,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 3650,
                            "hardware_cylinder": 449,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 10785,
                            "threshold": 144190,
                            "side_panels": {
                                "left_composite_id": 882,
                                "right_composite_id": 882,
                                "left": 1,
                                "right": 1,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_threshold_id": null,
                                "right_threshold_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                            "cill": 149,
                            "drainage": 1,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null,
                                "slab_width": "-124"
                            },
                            "hinge_qty": 29,
                            "couplers": {"sides": null, "top": null},
                            "touch_up_kit": 73,
                            "closer": 598,
                            "nuki_keypad": 65,
                            "nuki_keyfob": 67,
                            "tedee_keypad": 69,
                            "tedee_bridge": 71,
                        }
                    }
                };
            },
            supplied_loose_extra_text(item_id) {
              if (this.supplied_loose_item_ids.includes(item_id)) {
                return 'This item is supplied loose';
              } else {
                return '';
              }
            },
        },
    }
</script>
